import { Link, useLocation } from 'react-router-dom';
import { EyeOff } from 'lucide-react';
import SiteHeader from '@/components/SiteHeader';
import { useSiteVisibility } from '@/lib/siteVisibility';

const Unavailable = () => (
  <div className="min-h-screen bg-[#f4f8fb]">
    <SiteHeader />
    <main className="max-w-xl mx-auto px-6 pt-40 pb-24 text-center" data-testid="page-unavailable">
      <EyeOff size={36} className="mx-auto text-[#35AFE4]" />
      <h1 className="mt-5 text-2xl font-bold text-[#1e3a5f]">Page momentanément indisponible</h1>
      <p className="mt-3 text-gray-600">Cette page n'est pas accessible pour le moment. Retrouvez toute l'actualité de la SFOALC depuis l'accueil.</p>
      <Link to="/" className="inline-block mt-6 px-6 py-3 rounded-full bg-[#35AFE4] text-white font-bold hover:bg-[#1e9fd6] transition-colors" data-testid="page-unavailable-home">
        Retour à l'accueil
      </Link>
    </main>
  </div>
);

// Blocks pages unticked in Admin → Toutes les pages du site; super-admins still see them, with a notice.
export const HiddenPageGate = ({ children }) => {
  const { pathname } = useLocation();
  const { isHidden } = useSiteVisibility();
  if (!isHidden(pathname)) return children;
  const role = JSON.parse(localStorage.getItem('user') || 'null')?.role;
  if (role !== 'super_admin') return <Unavailable />;
  return (
    <>
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9995] px-4 py-2 rounded-full bg-[#1e3a5f] text-white text-xs font-semibold shadow-lg flex items-center gap-2" data-testid="hidden-page-admin-notice">
        <EyeOff size={13} /> Page masquée aux visiteurs — visible car vous êtes administrateur
      </div>
      {children}
    </>
  );
};
